/**
 * A failed request. `status` is missing when the server never answered;
 * `blockingTest` names the live test a 409 is waiting on.
 */
export class ApiRequestError extends Error {
  readonly status?: number;
  readonly blockingTest?: { id: string; name: string };

  constructor(message: string, status?: number, blockingTest?: { id: string; name: string }) {
    super(message);
    this.name = 'ApiRequestError';
    this.status = status;
    this.blockingTest = blockingTest;
  }
}
